<template>
    <div v-html="content"></div>
</template>

<script>
    import {Notify} from "vant";

    export default {
        name: "Privacy",
        data(){
            return{
                content:'',
                type: null
            }
        },
        created() {
            this.type = this.$route.query.type;
            this.getAgreement()
        },
        methods:{
            getAgreement(){
                window.$common.post('/master/config/get-agreement', {
                    type: this.type
                }).then(res => {
                    if (res.data.retcode === 1) {
                        this.content = res.data.obj.content;
                    } else {
                        Notify(res.data.msg.prompt);
                    }
                }).catch(err=>{
                    Notify(err);
                })
            },
        }
    }
</script>

<style scoped>

</style>